<template>
  <!-- 查看优惠券弹窗 -->
  <upPopup :show="value" @close="close" title="优惠" :showCloseBtn="true">
    <template v-for="(l, i) in list">
      <div :key="l.title" v-if="l.list.length">
        <p class="title">{{ l.title }}</p>
        <div
          class="item-box"
          :style="{ 'background-image': `url(${l.bg})` }"
          v-for="(item, index) in l.list"
          :key="index"
          @click="$emit('toOrderWithActive', { ...item, triggerInPopup: true })"
        >
          <template v-if="!i">
            <div class="item-l">{{ item.parsedPrice }}</div>
            <div class="item-r">
              <div class="item-r-content">
                <p class="item-type">{{ item.parsedType }}</p>
                <p class="item-deadline">使用期限：{{ item.parsedDeadline }}</p>
              </div>
              <div class="item-r-btn active">
                {{ +item.received === 1 ? '去使用' : '立即领取' }}
              </div>
            </div>
          </template>
          <template v-else>
            <div class="item-l">
              {{ (item.abbreviation || item.name).slice(0, 4) }}
            </div>
            <div class="item-r">
              <div class="item-r-content activity">
                <div v-for="p in item.prices" :key="item.id + p.waytype">
                  <span>
                    <span v-for="v in p.waytype_name" :key="v">{{ v }}</span>
                  </span>
                  ：
                  <span>{{ p.prices[0] }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </upPopup>
</template>

<script>
import upPopup from '../common/upPopup.vue'
import { preloadImage } from 'utils/tool.js'
import { sortByRule } from 'lib/tools/objOperation'

export default {
  components: {
    upPopup
  },
  props: {
    value: Boolean
  },
  computed: {
    bgImg() {
      return require('images/platform/homepage/coupon-bg.png')
    },
    activityBgImg() {
      return require('images/platform/homepage/activity-bg.png')
    },
    items() {
      const { coupons = [] } = this.$store.state.homepage.zxAdvancedInfo
      coupons.forEach(item => {
        item.frontIsCoupon = true
        switch (item.type) {
          // 现金
          case 'Cash':
            this.$set(item, 'parsedPrice', `￥${item.coupon_price}`)
            this.$set(item, 'parsedType', `现金优惠券`)
            break
          // 折扣
          case 'Discount':
            this.$set(item, 'parsedPrice', `${+item.discount / 10}折`)
            this.$set(item, 'parsedType', `折扣优惠券`)
            break
          // 免单
          case 'Free':
            this.$set(item, 'parsedPrice', '免单')
            this.$set(item, 'parsedType', `最高优惠${item.max_reduce}元`)
            break
        }
        if (item.expiry_type === 'DaysAfter') {
          this.$set(item, 'parsedDeadline', `领券后${item.expiry_date}天`)
        } else {
          this.$set(item, 'parsedDeadline', `截至${item.expiry_date}`)
        }
      })
      return coupons
    },
    activities() {
      const {
        packages = []
        // pre_consult = {}
      } = this.$store.state.homepage.zxAdvancedInfo
      const data = [...packages]
      // pre_consult.id && data.push(pre_consult)
      data.map(item => {
        sortByRule(item.prices, ['video', 'face', 'voice'], v => v.waytype)
      })
      return data
    },
    list() {
      return [
        { title: '领券', bg: this.bgImg, list: this.items || [] },
        { title: '活动', bg: this.activityBgImg, list: this.activities || [] }
      ]
    }
  },
  mounted() {
    // 预加载背景图
    preloadImage(this.bgImg)
    preloadImage(this.activityBgImg)
  },
  methods: {
    close() {
      this.$trackEvent('newprofilepages_discounts_close', {})
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #21252d;
  line-height: 128px;
}
.item-box {
  margin-bottom: 40px;
  width: 100%;
  height: 184px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  .item-l {
    width: 164px;
    padding: 25px;
    text-align: center;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .item-r {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px 0 30px;
    box-sizing: border-box;
    .activity > div {
      display: flex;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #21252d;
      line-height: 32px;
      & > span {
        display: inline-block;
        &:first-child {
          width: 130px;
          display: flex;
          justify-content: space-between;
        }
        &:last-child {
          color: #ffa202;
        }
      }
    }
  }
  .item-type {
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #38416b;
    line-height: 40px;
    margin-bottom: 10px;
  }
  .item-deadline {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
  }
  .item-r-btn {
    flex-shrink: 0;
    width: 130px;
    height: 50px;
    background: #ffa202;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    &.active {
      background: #ff745b;
      color: #ffffff;
    }
  }
}
</style>
